import { ChangeEvent, useState } from "react";
import { LInputField } from "../../../common/components/LInputField";
import { LSelect, SelectOption } from "../../../common/components/LSelect";

// TODO: create generic component
export const CountrySelectOptions = ({ ...props }: CountrySelectProps): JSX.Element => {
    const options = [{ name: "United States" } as SelectOption, { name: "Other" } as SelectOption];

    const [showOther, setShowOther] = useState(props.value === "Other");

    const handleSelect = (e: ChangeEvent<HTMLInputElement>): void => {
        setShowOther(e.target.value === "Other");
    };

    return (
        <>
            {!props.hideSelect && (
                <LSelect
                    options={options}
                    label="Country"
                    defaultValue={props.value}
                    defaultOption={{ name: "Select country", value: "" } as SelectOption}
                    onChange={handleSelect}
                    inputName={props.inputName ?? "country"}
                    disabled={props.disabled}
                />
            )}
            {showOther && (
                <LInputField
                    inputName="otherCountry"
                    label="Please specify other country"
                    placeholder="Enter country"
                    defaultValue={props.otherCountry}
                    disabled={props.disabled}
                />
            )}
        </>
    );
};

interface CountrySelectProps {
    /** The initial value */
    value?: string;
    /** The other job title field value */
    otherCountry?: string;
    disabled?: boolean;
    hideSelect?: boolean;
    inputName?: string;
}
